<template>
  <a-modal v-model:visible="visible" title="导出成功" :after-close="onClose">
    <div class="flex items-center justify-center flex-col">
      <icon :icon="'Vector.svg'" :width="48" :height="48" fill="none" />
      <span class="mt-2 text-base">已生成表盘bin文件！</span>
      <span
        class="mt-2 opacity-70 text-center w-2/3 hover:underline hover:cursor-pointer"
        @click="showBin"
        >{{ binPath }}</span
      >
    </div>

    <template #footer>
      <a-button key="back" @click="close">关闭</a-button>
      <a-button type="default" @click="showBin"> 查看bin文件 </a-button>
      <a-button type="primary" @click="packMwz"> 导出mwz包 </a-button>
    </template>
  </a-modal>
</template>

<script lang="ts" setup>
import { ElectronApi } from '@/services/electron.api';
import { ref } from 'vue';
import { saveAs } from 'file-saver';
import { message } from 'ant-design-vue';

const visible = ref(false);

const binPath = ref('');
const mwzBlob = ref<Blob>();

defineExpose({
  open: (_binPath: string, _mwzBlob?: Blob) => {
    binPath.value = _binPath;
    mwzBlob.value = _mwzBlob;
    visible.value = true;
  }
});

const showBin = () => {
  ElectronApi.showItemInFolder(binPath.value);
};

const packMwz = async () => {
  const _watchfacePath = ElectronApi.path?.dirname(binPath.value);
  if (!_watchfacePath) return;
  const bf = mwzBlob.value;
  if (!bf) return;
  const basename = ElectronApi.path?.basename(_watchfacePath) ?? '表盘文件';
  message.success('导出成功，请保存');
  saveAs(bf, basename + '.mwz');
};

const close = () => {
  visible.value = false;
};
const onClose = () => {
  binPath.value = '';
  mwzBlob.value = undefined;
};
</script>
